import React from 'react';
import './style.scss';

const PendingSkeleton = () => {
  return (
    <div className="pending-skeleton">
      {Array.from({ length: 8 }).map((_, index) => (
        <div className="pending-skeleton__card" key={index}>
          <div className="pending-skeleton__title loadingBlock" />
          <div className="pending-skeleton__subtitle loadingBlock" />
        </div>
      ))}
    </div>
  );
};

export default PendingSkeleton;
